/**
 * @fileoverview Agent definition for character-image-creator-fal-v2.
 *
 * This agent generates a character portrait image from a detailed prompt
 * using the fal.ai provider for high-quality image generation.
 *
 * @category visuals.images.characters
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-image-creator-fal-v2',
  kind: 'primitive',
  name: 'Character Image Creator (FAL)',
  description: 'Generates a character portrait image from a detailed prompt using the fal.ai provider.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-07',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.images.characters',
    usedBy: [
      'use-portrait-generation-fal-v2.ts',
      'use-character-image-generation-fal-v2.ts',
      'use-writing-visualization-fal-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-image-creator-v2',
      'character-image-prompt-creator-v2',
      'multi-reference-image-creator-fal-v2',
    ],
  },
};
